<template>
    <div id="buyers_wrapper">
        <v-dialog 
            v-model="buyerQuestionnaire_dialog" 
            transition="dialog-bottom-transition"
            max-width="83%"
            scrollable>
            <v-card>
                <v-card-title class="info pewter--text d-flex justify-space-between">
                    <div class="justify-start mr-12">{{ thisBuyer.buyer_data.name }}</div>
                    <div class="d-flex flex-grow-1">
                        <div class="justify-start mr-6">{{ thisBuyer.buyer_data.email }}</div>
                        <v-divider v-if="thisBuyer.buyer_data.phone" vertical class="pewter"></v-divider>
                        <div class="justify-center mx-6">{{ thisBuyer.buyer_data.phone }}</div>
                        <v-divider v-if="thisBuyer.buyer_data.location_text" vertical class="pewter"></v-divider>
                        <div class="justify-end ml-6">{{ thisBuyer.buyer_data.location_text }}</div>
                    </div>
                    <div class="justify-end">
                        <v-btn 
                            icon 
                            dark 
                            class="ml-3"
                            @click="buyerQuestionnaire_dialog = false">
                            <v-icon color="pewter">mdi-close</v-icon>
                        </v-btn>
                    </div>
                </v-card-title>
                <v-card-text>
                    <BuyerQuestionnaire 
                        :user_id="thisBuyer.buyer_id"
                        :is_secondary="thisBuyer.is_secondary"
                        :project_id="thisBuyer.project_id"
                        module_key="buyer"
                        module_id="5d357103-3744-4e52-885f-5247d42fa47b"
                        :isOpen="buyerQuestionnaire_dialog"
                    />
                </v-card-text>
                <v-card-actions class="info">
                    <v-spacer></v-spacer>
                    <!-- LEAVE COMMENTED IN CASE WE DON'T LIKE THE FIXED HEIGHT
                    <v-btn
                        outlined
                        color="pewter"
                        class="mr-3"
                        @click="buyerQuestionnaire_dialog = false">
                        close
                    </v-btn> -->
                </v-card-actions>
            </v-card>
        </v-dialog>

        <div class="sansation info--text d-inline px-4"><h2>Search Buyers</h2></div>

        <div class="d-flex d-block px-4 my-4 py-6">
            <div style="width: 60%">
                <div v-if="searchCounter > 0">
                    <div
                        v-for="num in searchCounter"
                        :key="num"
                        class="d-flex d-inline">
                        <v-select
                            :items="lookup_options"
                            v-model="searches.question[num - 1]"
                            hide-details
                            class="d-inline mr-9"
                            label="Choose a category to lookup"
                            style="width: 20%"
                            @change="selectedQuestion(num - 1)">
                        </v-select>
                        <v-select
                            v-if="show_secondary_select"
                            :items="list_options[num - 1]"
                            v-model="searches.criteria[num - 1]"
                            hide-details
                            class="d-inline"
                            label="Select criteria"
                            @change="selectedCriteria">
                            <!-- :label="`Select ${indefinite_article} ${selected_list_name}`"> -->
                        </v-select>
                        <v-icon
                            v-if="num > 1"
                            class="mt-3 ml-3"
                            @click="removeSearch(num)">
                            mdi-close
                        </v-icon>
                    </div>
                </div>
            </div>

            <div class="align-end">
                <div class="d-flex d-inline">
                    <v-icon
                    v-if="show_submit"
                    class="mt-3 ml-3"
                    @click="addSearch()"
                    >
                    mdi-plus
                    </v-icon>
                    <v-btn
                        v-if="show_submit"
                        outlined
                        color="primary darken-1"
                        class="mt-3 ml-3 d-inline"
                        @click="searchBuyers()">
                        Search
                    </v-btn>
                    <v-btn
                        v-if="buyers.length"
                        color="primary darken-1"
                        hide-details
                        class="mt-3 ml-4 d-inline"
                        :loading="exporting"
                        @click="exportBuyerSearch()">
                        Export
                    </v-btn>
                    <h2 v-if="buyer_count !== false"
                        class="d-inline d-flex ml-6 pb-2 accent--text text--darken-3 font-weight-medium align-end">
                        {{ buyer_count }} {{ buyer_count == 1 ? 'buyer' : 'buyers' }} found
                    </h2>
                </div>
            </div>
        </div>
        
        <div class="buyers-table-scroll">
            <v-data-table
                :headers="buyers_header"
                :items="buyers"
                item-key="buyer_id"
                fixed-header
                class="elevation-0 buyers_table"
                :height="'calc(90vh - 320px)'"
				loader-height="6"
                sort-by="state"
                :items-per-page="-1"
                :loading="table_loading"
                loading-text="Loading... Please wait"
                style="border-top: 1px solid #D9D9D9">
                
                <template v-slot:no-data>
                    <div class="text-center pt-12">
                        <v-icon large>mdi-alert-circle</v-icon>
                        <p class="mt-2">No buyers found matching your filters.</p>
                    </div>
                </template>

                <template v-slot:no-results>
                    <div class="text-center pt-12">
                        <v-icon large>mdi-alert-circle</v-icon>
                        <p class="mt-2">No buyers found matching your filters.</p>
                    </div>
                </template>

                <template v-slot:[`item.buyer_data`]="{ item }">
					<td class="py-2 px-0 text-start align-text-center">
                        <div class="d-block">
                            {{ item.buyer_data.name }}
                        </div>
                        <div class="d-block d-flex align-items-center">
                            <v-tooltip top content-class="contact_tooltip">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn 
                                        icon
                                        x-small
                                        class="d-inline mr-1"
                                        color="primary"
                                        v-bind="attrs"
                                        v-on="on"
                                        target="_blank"
                                        @click.stop
                                        :href="`mailto:${item.buyer_data.email}`">
                                        <v-icon>mdi-email</v-icon>
                                    </v-btn>                            
                                </template>
                                <span>Email: {{ item.buyer_data.email }}</span>
                            </v-tooltip>

                            <v-tooltip top content-class="contact_tooltip">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn 
                                        icon
                                        x-small
                                        class="d-inline mr-1"
                                        color="primary"
                                        v-bind="attrs"
                                        v-on="on"
                                        @click.stop="beginCall(item.buyer_data.phone)">
                                        <v-icon>mdi-phone</v-icon>
                                    </v-btn>
                                </template>
                                <span>Call: {{ item.buyer_data.phone }}</span>
                            </v-tooltip>

                            <v-tooltip top content-class="contact_tooltip">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon 
                                        small 
                                        class="d-inline primary--text text--darken-1"
                                        v-bind="attrs"
                                        v-on="on"
                                        @click.stop="buyerQuestionnaire(item)">
                                        mdi-open-in-new
                                    </v-icon>
                                </template>
                                <span>Open Profile</span>
                            </v-tooltip>
                        </div>
                    </td>
                </template>

                <template v-slot:[`item.listings`]="{ item }">
                    <td class="py-2 px-0">
                        <div
                            v-for="(listing, ndx) in item.listings"
                            :key="ndx"
                            class="d-block listings"
                            :style="listing.includes('Reject') || listing.includes('Bad Buyer') ? 'color:#9E9E9E' : 'color:#3693a1'"
                            v-html="listing">
                        </div>
                    </td>
                </template>

                <template v-slot:[`item.aum`]="{ item }">
                    <td class="py-2 px-0">    
                        <div class="text-start">{{ item.formatted_aum }}</div>
                    </td>
                </template>

                <template v-slot:[`item.custodian-affiliation`]="{ item }">
                    <td class="py-2 px-0" v-if="item['custodian-affiliation'] && item['custodian-affiliation'].length">
                        <div class="text-start" v-html="item['custodian-affiliation'].join(',<br>')"></div>
                    </td>
                </template>

                <template v-slot:[`item.association-affiliation`]="{ item }">
                    <td class="py-2 px-0" v-if="item['association-affiliation'] && item['association-affiliation'].length">
                        <div class="text-start" v-html="item['association-affiliation'].join(',<br>')"></div>
                    </td>
                </template>

                <template v-slot:[`item.fund-companies-affiliation`]="{ item }">
                    <td class="py-2 px-0" v-if="item['fund-companies-affiliation'] && item['fund-companies-affiliation'].length">
                        <div class="text-start" v-html="item['fund-companies-affiliation'].join(',<br>')"></div>
                    </td>
                </template>

                <template v-slot:[`item.tamps-affiliation`]="{ item }">
                    <td class="py-2 px-0" v-if="item['tamps-affiliation'] && item['tamps-affiliation'].length">
                        <div class="text-start" v-html="item['tamps-affiliation'].join(',<br>')"></div>
                    </td>
                </template>

                <template v-slot:[`item.imo-affiliation`]="{ item }">
                    <td class="py-2 px-0" v-if="item['imo-affiliation'] && item['imo-affiliation'].length">
                        <div class="text-start" v-html="item['imo-affiliation'].join(',<br>')"></div>
                    </td>
                </template>

                <template v-slot:[`item.tax-planning-experience`]="{ item }">
                    <td class="py-2 px-0" v-if="item['tax-planning-experience']">
                        <div class="text-start" v-html="item['tax-planning-experience'] == 'yes' ? 'Yes' : 'No'"></div>
                    </td>
                </template>
            
            </v-data-table>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import Cookie from 'js-cookie';
    import { saveAs } from 'file-saver';

    import appUrls from '../../helpers/environment';
    import { formatBigInt, formatPhoneNumber, capitalizeFirstOfEachWord } from '../../helpers/utilities'
    import UserData_Dashboard from '../UserData_Dashboard.vue'
    import BuyerQuestionnaire from '../ModuleQuestionnaire'

    export default {
        name: 'SearchBuyers',

        components: {
            UserData_Dashboard,
            BuyerQuestionnaire 
        },

        props: {
            triggerUserFeedback: Function
        },
        
        data: () => ({
            buyers: [],
            buyer_count: false,
            calc_visual_height: 360,
            buyerQuestionnaire_dialog: false,
            thisBuyer: {
                buyer_data: {
                    name: ''
                }
            },

            associations: [],
            broker_dealers: [{text: 'None', value: 'none'}],
            custodians: [],
            tamps: [],
            imos: [],
            fund_companies: [],
            states: [],
            yes_no: [],
            aum_ranges: [
                { text: '0 - $250 million',            value: 0 },
                { text: '$251 million - $500 million', value: 1 },
                { text: '$501 million - $750 million', value: 2 },
                { text: '$751 million - $1 billion',   value: 3 },
                { text: '$1 billion +',                value: 4 },
            ],

            sections: [],
            question: [],

            selected_list_key: '',
            selected_list_name: '',
            indefinite_article: 'a',

            show_secondary_select: false,
            show_submit: false,
            searchCounter: 1,
            searches: {
              question: [],
              criteria: []
            },

            search_params: {
                section_key: '-',
                question_key: '',
                criteria_value: '',
                evaluator: 'contains',
                extrafield_keys: '-',
                // extrafield_keys: 'aum,tax-planning-experience-description',
            },

            lookup_options: [
                { text: 'Associations', value: 'association-affiliation', list: 'associations', ask: 'association-affiliation-ask' },
                { text: 'AUM', value: 'aum', list: 'aum_ranges', ask: 'aum' },
                { text: 'Broker Dealers', value: 'broker-dealer-affiliation', list: 'broker_dealers', ask: 'broker-dealer' },
                { text: 'Custodians', value: 'custodian-affiliation', list: 'custodians', ask: 'custodian' },
                { text: 'Fund Companies', value: 'fund-companies-affiliation', list: 'fund_companies', ask: 'fund-companies' },
                { text: 'IMO', value: 'imo-affiliation', list: 'imos', ask: 'imo' },
                { text: 'State', value: 'state', list: 'states', ask: '' },
                { text: 'TAMPS', value: 'tamps-affiliation', list: 'tamps', ask: 'tamps' },
                { text: 'Tax Business', value: 'tax-planning-experience', list: 'yes_no', ask: 'tax-planning-experience' }
            ],

            affiliation_fields: [
                'broker-dealer-affiliation',
                'custodian-affiliation',
                'association-affiliation',
                'fund-companies-affiliation',
                'tamps-affiliation',
                'imo-affiliation'
            ],

            list_options: [],

            days_before_now: [
                { value: 10, text: '10 Days' },
                { value: 30, text: '30 Days' },
                { value: 60, text: '60 Days' },
                { value: 90, text: '90 Days' },
            ],

            base_buyers_header: [
                // { text: 'First Name',   value: 'first-name', align: 'start', sortable: true, class: 'tbl_headers' },
                // { text: 'Last Name',    value: 'last-name',  align: 'start', sortable: true, },
                // { text: 'Title',        value: 'title',      align: 'start', sortable: true, },
                // { text: 'Email',        value: 'email',      align: 'start', sortable: true, },
                // { text: 'Phone',        value: 'phone',      align: 'start', sortable: true, },
                { text: 'Buyer',    value: 'buyer_data', align: 'start', sortable: false, class: 'tbl_headers' },
                { text: 'City',     value: 'city',       align: 'start', sortable: true, },
                { text: 'State',    value: 'state',      align: 'start', sortable: true, },
                { text: 'Listings', value: 'listings',   align: 'start', sortable: true, }
            ],
            buyers_header: [],

            table_loading: false,
            exporting: false,
            lastSearchArr: [],
            formatted_aum: '',
            run_cnt: 0
        }),

        watch: {
            selected_list_name (val) {
                let text = val
                if ( !val.endsWith('Business') && val.endsWith('s') || val.endsWith('S') ) {
                    if ( val.endsWith('ies') ) {
                        text = val.replace('ies', 'y')
                    } else {
                        text = val.substr(0, val.length-1)
                    }
                }
                this.selected_list_name = text

                // STARTS WITH A VOWEL - GET PROPER INDEFINITE ARTICLE
                this.indefinite_article = 'a'
                let vowel_start = val.substr(0, 1)
                if ( ['A','E','I','O','U'].includes(vowel_start) ) {
                    this.indefinite_article = 'an'
                }
            },
        },
        created () {
            // this.exportViaBufferData()

            this.getLists()
            this.buyers_header = this.base_buyers_header        
        },

        mounted () {
            this.searchBuyers()       
        },

        methods: {
            buyerQuestionnaire (buyer) {
                // console.log(buyer)
                this.thisBuyer = {...buyer}
                this.thisBuyer.is_secondary = false
                this.thisBuyer.project_id = buyer.project_id

                setTimeout(()=>{
                    this.buyerQuestionnaire_dialog = true;
                }, 1000)
            },

            closeQuestionnaire: function () {
                this.thisBuyer = {}
                this.buyerQuestionnaire_dialog = false;
            },

            getLists: async function () {
                let optionsLists = [ 
                    {'name': 'listing_types', 'type': 'int'}, 
                    {'name': 'listing_stages', 'type': 'int'},
                    {'name': 'buyer_status', 'type': 'int'}, 
                    {'name': 'states', 'type': 'txt'},
                    {'name': 'broker_dealers', 'type': 'txt'},
                    {'name': 'custodians', 'type': 'txt'},
                    {'name': 'tamps', 'type': 'txt'},
                    {'name': 'imos', 'type': 'txt'},
                    {'name': 'fund_companies', 'type': 'txt'},
                    {'name': 'associations', 'type': 'txt'},
                    {'name': 'yes_no', 'type': 'txt'},
                ];

                axios.post(`${appUrls.api}/api/lists`, {
                    headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                    list_options: optionsLists
                })
                .then( res => {
                    //console.log(res.data)
                    if(res.data.outcome){
                        let arrLists = res.data.lists;                        
                        // SET PROPERTIES WITH THIER APPROPRIATE LIST
                        for (let l in arrLists) {
                            if (arrLists[l].name == 'states') this.states = arrLists[l].list
                            if (arrLists[l].name == 'buyer_status') this.buyer_status = arrLists[l].list
                            if (arrLists[l].name == 'listing_stages') this.listing_stages = arrLists[l].list
                            if (arrLists[l].name == 'listing_types') this.listing_types = arrLists[l].list
                            if (arrLists[l].name == 'broker_dealers') Array.prototype.push.apply(this.broker_dealers, arrLists[l].list)
                            if (arrLists[l].name == 'custodians') this.custodians = arrLists[l].list
                            if (arrLists[l].name == 'tamps') this.tamps = arrLists[l].list
                            if (arrLists[l].name == 'imos') this.imos = arrLists[l].list
                            if (arrLists[l].name == 'fund_companies') this.fund_companies = arrLists[l].list
                            if (arrLists[l].name == 'associations') this.associations = arrLists[l].list
                            if (arrLists[l].name == 'yes_no') this.yes_no = arrLists[l].list
                        }
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
            },

            getSections: async function () {
                const module_id = '5d357103-3744-4e52-885f-5247d42fa47b'

                axios.get(`${appUrls.api}/api/questionnaire_sections/${module_id}`, {
                    headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                })
                .then( res => {
                    //console.log(res.data)
                    if(res.data.outcome){
                        this.sections = res.data.sections
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
            },

            getQuestions: async function ( section_id ) {
                const module_id = '5d357103-3744-4e52-885f-5247d42fa47b'

                axios.get(`${appUrls.api}/api/questionnaire_section_questions/${section_id}`, {
                    headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                })
                .then( res => {
                    //console.log(res.data)
                    if(res.data.outcome){
                        this.questions = res.data.questions
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
            },

            selectedQuestion: async function (num) {
                // this.list_options=[]
                this.search_params.criteria_value=''

                const selected_lookup_option = this.lookup_options.find(type => type.value == this.searches.question[num])
                this.selected_list_key = selected_lookup_option ? selected_lookup_option.list : 'default'
                // this.selected_list_name = this.lookup_options.find(type => type.value == this.searches.criteria[num]).text

                const match = ( expression, cases ) => {
                    return cases[expression]
                }
                
                this.list_options[num] = match(this.selected_list_key, {
                    broker_dealers: this.broker_dealers,
                    custodians: this.custodians,
                    imos: this.imos,
                    fund_companies: this.fund_companies,
                    states: this.states,
                    tamps: this.tamps,
                    associations: this.associations,
                    aum_ranges: this.aum_ranges,
                    yes_no: this.yes_no,
                    default: []
                })
                this.show_secondary_select = true
            },

            selectedCriteria: async function () {
                this.show_submit = true
                // console.log( this.search_params )
            },

            addSearch: function () {
                if (this.searchCounter > 5) {
                    return
                }
                this.searchCounter++
                this.buyers_header = [...this.base_buyers_header]
            },

            removeSearch: function(num) {
              this.searches.question.splice(num - 1, 1)
              this.searches.criteria.splice(num - 1, 1)
              this.list_options.splice(num - 1, 1)
              this.searchCounter--
              this.buyers_header = [...this.base_buyers_header]
            },

            searchBuyers: async function () {
                this.table_loading = true
                let searchArr = []

                for (let i = 0; i < this.searches.question.length; i++) {
                    searchArr.push({question: this.searches.question[i], criteria: this.searches.criteria[i] })
                    
                    if ( this.affiliation_fields.includes(searchArr[i].question) && searchArr[i].criteria === 'other' ) {
                        searchArr[i].criteria = 'other'
                    }

                    // console.log("questions: ", this.searches.question.length)
                    // this.calc_visual_height = this.calc_visual_height + (this.searches.question.length * 10)
                    // console.log("calc_visual_height: ", this.calc_visual_height )
                }
                // console.log("searchArr", searchArr)

                this.buyers_header = [...this.base_buyers_header]
                searchArr.forEach(search_q => {
                    // do not add another object if the object with the same value already exists in the buyers_header array (this can happen when adding multiple search criteria)
                    if ( this.buyers_header.filter(col => col.value === search_q.question).length === 0 ) {
                        const header_text = search_q.question.replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
                        // this.buyers_header.splice(this.buyers_header.length-1, 0, { text: header_text, value: search_q.question, width: '', align: 'start', sortable: true })
                        this.buyers_header.push({ text: header_text, value: search_q.question, align: 'start', sortable: true, width: '' })
                    }
                })

                try {
                    const get_buyers = await axios.post(`${appUrls.api}/api/admin/buyer_report_search`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                        data: {
                            module_id: '5d357103-3744-4e52-885f-5247d42fa47b',
                            searchArr
                        }
                    })

                    if ( get_buyers.data.outcome ){
                        // export uses the criteria that produced the current table
                        this.lastSearchArr = searchArr
                        if ( get_buyers.data.buyers.length ) {
                            this.buyers = get_buyers.data.buyers
                            this.buyer_count = get_buyers.data.buyers.length

                            for (let b in this.buyers) {
                                this.buyers[b].listings = JSON.parse(JSON.stringify(this.buyers[b].listings))
                                if ( this.buyers[b].aum ) {
                                    this.buyers[b].aum = this.buyers[b].aum
                                    this.buyers[b].formatted_aum = formatBigInt(this.buyers[b].aum)
                                }
                            }

                            this.table_loading = false;
                            this.$emit('triggerUserFeedback', true, get_buyers.data.message)
                        } else {
                            this.buyers = []
                            this.buyer_count = 0    
                            this.table_loading = false

                            this.run_cnt++
                            if ( this.run_cnt > 1) {
                                this.$emit('triggerUserFeedback', true, get_buyers.data.message, 'accent')
                            }
                        }
                    } else {
                        this.buyers = []
                        this.buyer_count = 0    
                        this.table_loading = false
                        this.$emit('triggerUserFeedback', true, 'There was a problem searching for buyers.', 'accent')
                    }
                } catch( error ) {
                  console.log(error)
                }
            },

            exportBuyerSearch: async function () {
                this.exporting = true

                try {
                    const export_rs = await axios.post(`${appUrls.api}/api/admin/buyer_report_search/export`, {
                        module_id: '5d357103-3744-4e52-885f-5247d42fa47b',
                        searchArr: this.lastSearchArr
                    }, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" }
                    })

                    if ( export_rs.data.outcome && export_rs.data.buf ) {
                        this.exportViaBufferData(export_rs.data.buf)
                    } else {
                        this.$emit('triggerUserFeedback', true, 'There was a problem exporting buyers.', 'accent')
                    }
                } catch ( error ) {
                    console.log(error)
                    this.$emit('triggerUserFeedback', true, 'There was a problem exporting buyers.', 'accent')
                } finally {
                    this.exporting = false
                }
            },

            exportViaBufferData ( buffer_data ) {
                const this_fileExt = '.xlsx';
                const this_fileDate = this.createDateString();
                const this_fileData = new Buffer(buffer_data, 'base64');
                const this_fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                const this_fileName = 'buyer_search-export_'+this_fileDate+this_fileExt;
                
                const this_blob = new Blob([this_fileData], {type: this_fileType});
                saveAs(this_blob, this_fileName);
            },

            createDateString (date=false) {
                const d         = date ? new Date (date) : new Date()
                const year      = String(d.getFullYear())
                const month     = String(d.getMonth()+1).padStart(2, '0')
                const day       = String(d.getDate()).padStart(2, '0')
                const secs      = String(d.getSeconds())
                const msec      = String(d.getMilliseconds())
                return year.concat('', month.concat('', day.concat('', secs.concat('', msec))));
            },

            openDetailsNewTab ( item ) {
                let route = this.$router.resolve({ path: `/user_details/${item.buyer_id}`});
                window.open(route.href, '_blank');
            }
        }
    }
</script>

<style scoped>
    #buyers_wrapper {
        width: 100%;
        margin: 0 auto;
        padding: 1rem 0 0 0;
        display: flex;
        flex-direction: column;
        /* height: 100vh; */
    }
    tr:nth-of-type(even) {
        background-color: rgba(223, 233, 236, .25);
        /* background-color: rgba(0, 0, 0, .05); */
        /* background-color: rgba(226, 249, 253, 0.45); */
    }

    .buyers_table >>> td {
		padding-top: .25em !important;
		padding-bottom: .25em !important;
		padding-left: 0 !important;
		padding-right: 0 !important;
		margin-left: 0 !important;
		margin-right: 0 !important;
		vertical-align: top !important;
		font-size: small !important;
	}
    .buyers_table >>> td:nth-of-type(1) {
		padding-left: .25em !important;
	}
	.buyers_table >>> th {
		/* padding-top: .5em !important;
		padding-bottom: .5em !important; */
        padding-left: 0 !important;
		padding-right: 0 !important;
		font-size: .8em !important;
		/* vertical-align: center !important; */
		background-color: #eef7f8 !important;
	}
    .buyers_table >>> th:nth-of-type(1) {
		padding-left: .30em !important;
	}

    .buyers-table-scroll {
        overflow-x: auto;
        width: 100%;
    }

    .v-data-table__wrapper {
        overflow-x: auto !important;
        overflow-y: auto !important;
}
    .v-data-table { 
        overflow-x: scroll !important;
        overflow-y: scroll !important;
    }

    /* >>> tbody tr {
        cursor: pointer !important;
    }
    td.no_extra_border {
        border-bottom: 0 !important;
    }

    .v-data-table__wrapper {
        overflow-x: auto !important;
        overflow-y: auto !important;
}
    .v-data-table { 
        overflow-x: scroll !important;
        overflow-y: scroll !important;
    }
 >>> .v-data-table .v-data-table__wrapper > table > thead > tr > th {
        padding: 0 .8em 0 .8em !important;
        font-size: x-small !important;
        color: #333 !important;
        margin: 0 !important;
        height: 36px !important;
        border-top: 1px solid #EDEDED !important;
    }
 >>> .v-data-table .v-data-table__wrapper > table > tbody > tr > td {
        padding: .8em !important;
        margin: 0 !important;
        font-size: small !important;
        cursor: pointer !important;
        vertical-align: top !important;
    }
    .tbl_headers {
        padding: 0 !important;
    }
    */

    div.listings:nth-of-type(even) {
        /* background-color: #eef7f8; */
        padding: 2px 0;
    }
    .drawer-content {
        height: 100%; /* Full height of the drawer */
        overflow-y: auto; /* Allow vertical scrolling */
    }
    /* Hide scrollbar but allow scrolling */
    .drawer-content::-webkit-scrollbar {
        display: none; /* For Chrome, Safari, and Edge */
    }
    .drawer-content {
        -ms-overflow-style: none; /* For Internet Explorer and Edge */
        scrollbar-width: none; /* For Firefox */
    }
    .contact_tooltip {
        font-size: .8rem !important;
        padding: .25rem .8rem !important;
        margin-top: .2rem !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/reports/SearchBuyers.vue